import React from "react";
import "./PersonTag.css";
import { NavLink } from "react-router-dom";

export const PersonTag = (props) => {
    const {personData} = props;

    const person_name = personData.name;
    const person_department = personData.known_for_department;
    let person_img = "";

    if (personData.profile_path){
        person_img =
          "https://www.themoviedb.org/t/p/w600_and_h900_bestv2" +
          personData.profile_path;
    }else{
        if (personData.gender == 1){
            person_img = "https://media.istockphoto.com/vectors/default-placeholder-woman-vector-id844000348?k=6&m=844000348&s=612x612&w=0&h=2QiYy7vaGEt7MlzlMnLPhUSbRNw2FzwoLc6lTXh-3vA="
        }else{
            person_img = "https://media.istockphoto.com/vectors/default-placeholder-profile-icon-vector-id666542874?k=6&m=666542874&s=612x612&w=0&h=51neckTVJA8FxzPQs08oR50k6987AOIv97ugl3DYjLc="
        }
    }

    const person_work = personData.known_for;

    return (
      <div className="person_tag_wrapper">
        <div className="person_tag_img">
          <img
            src={person_img}
            width={personData.profile_path ? "" : "600px"}
          ></img>
        </div>
        <div className="person_tag_info_wrapper">
          <div className="person_info">
            <div className="person_name">{person_name}</div>
            <div className="person_department">{person_department}</div>
          </div>
          <div className="person_work_wrapper">
            {person_work.map((item) => (
              <NavLink
                className="nav_link"
                to={`/details/${item.media_type == "tv" ? "tv" : "mov"}/${
                  item.id
                }`}
              >
                <div className="work_title">{item.name || item.title}</div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    );
}